import Link from '@/_application/core/components/ui/link';
import React from 'react';

export type PathFooter = {
    title: string;
    key: string;
};

interface IProps {
    title: string;
    paths: PathFooter[];
}

function NavigationFooter({title, paths}: Readonly<IProps>) {
    return (
        <div>
            <p className="text-[14px] font-bold uppercase leading-[19px] text-primary">{title}</p>
            <div className="mt-3 grid gap-2">
                {paths.map(path => (
                    <a
                        key={path.key}
                        target="_blank"
                        href={path.key}
                        className="text-xs text-KPZ_Gray-30 transition-colors hover:text-primary">
                        {path.title}
                    </a>
                ))}
            </div>
        </div>
    );
}

export default NavigationFooter;
